/** Frontmatter for the "draft-by-tiers" article; the Body lives in draft-by-tiers.jsx. */
const meta = {
  slug: 'draft-by-tiers',
  title: 'Draft by Tiers, Not by Rank',
  category: 'Draft',
  excerpt: 'Ranked lists make every pick feel like a cliff. Tiers tell you when a cliff is actually there, and when it is safe to wait.',
  readMinutes: 5,
  date: '2026-08-01',
};

export default meta;
